import { defineCustomElements } from 'ids-wc/dist/loader';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.tsx';
import './i18n.ts';
import './index.css';
import { store } from './shared/store/index.ts';
import { validateEnvironmentVariables } from './utils/env-validation.ts';

defineCustomElements(window);
validateEnvironmentVariables();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
